import { FunctionComponent, ReactNode } from 'react';
import getConfig from 'next/config';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import EditIcon from 'theme/icons/edit.svg';
import FacebookIcon from 'theme/icons/socials/facebook.svg';
import InstagramIcon from 'theme/icons/socials/instagram.svg';
import LinkedinIcon from 'theme/icons/socials/linkedin.svg';
import SuitcaseIcon from 'theme/icons/suitcase.svg';
import WebsiteIcon from 'theme/icons/website.svg';
import WorkersIcon from 'theme/icons/workers.svg';
import Placeholder from 'theme/images/avatar-placeholder.svg';

import Button, { ButtonIconPositions, ButtonIconTypes, ButtonStyles } from 'components/layout/Button';

import { Props } from './index';
import StyledComponent from './styles';

const SocialLink = (socialLink: string, icon: any): ReactNode => (
    <a
        href={socialLink.includes('http') ? socialLink : `https://${socialLink}`}
        rel="noreferrer noopener"
        target="_blank"
        className='company-socials__link'
    >
        <img
            className='social'
            src={icon}
            alt=""
            loading="lazy"
        />
    </a>
);

const PublicPageJobSectionJobBlocksJobHeader: FunctionComponent<Props> = ({
    company: {
        company: { name, shortName },
        employeesCount,
        jobCategory,
        description,
        logo,
        facebookUrl,
        instagramUrl,
        linkedinUrl,
        websiteUrl,
    },
    isEditable,
}) => {
    const { publicRuntimeConfig } = getConfig();
    const router = useRouter();
    return (
        <StyledComponent className="public-page-company-site-section-company-block-header">
            {isEditable && (
                <>
                    <div className='button-edit button-edit--desktop'>
                        <Button
                            onClick={() => router.push(publicRuntimeConfig.COMPANY_PANEL_URL + Routes.CompanySite)}
                        >
                    Edytuj stronę
                        </Button>
                    </div>
                    <div className='button-edit button-edit--mobile'>
                        <Button
                            style={ButtonStyles.None}
                            icon={{
                                position: ButtonIconPositions.Before,
                                type: ButtonIconTypes.Image,
                                value: EditIcon,
                            }}
                            onClick={() => router.push(publicRuntimeConfig.COMPANY_PANEL_URL + Routes.CompanySite)}
                        >
                            Edytuj stronę
                        </Button>
                    </div>
                </>
            )}
            <div className="cols">
                <div className="left-col col">
                    <div className="logo-container">
                        <img
                            className="logo"
                            src={logo?.imageUrl || Placeholder}
                            alt=""
                            loading="lazy"
                        />
                    </div>
                </div>

                <div className="right-col col">
                    <p className="company-name">{shortName || name}</p>
                    <div className="company-details">
                        <div className="company-info">
                            {employeesCount && (
                                <div className="info">
                                    <img
                                        className="info-icon"
                                        src={WorkersIcon}
                                        alt=""
                                        loading="lazy"
                                    />
                                    <span>{employeesCount} pracowników</span>
                                </div>
                            )}
                            <div className="info">
                                { jobCategory?.name && (
                                    <>
                                        <img
                                            className="info-icon"
                                            src={SuitcaseIcon}
                                            alt=""
                                            loading="lazy"
                                        />
                                        <span>{jobCategory?.name}</span>
                                    </>
                                )}
                            </div>
                        </div>

                        <div className="company-description">
                            <p>
                                {description}
                            </p>
                        </div>

                        <div className="company-socials">
                            {facebookUrl && (
                                SocialLink(facebookUrl, FacebookIcon)
                            )}
                            {instagramUrl && (
                                SocialLink(instagramUrl, InstagramIcon)
                            )}
                            {linkedinUrl && (
                                SocialLink(linkedinUrl, LinkedinIcon)
                            )}
                            {websiteUrl && (
                                SocialLink(websiteUrl, WebsiteIcon)
                            )}
                        </div>
                    </div>


                </div>
            </div>
        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobHeader;
